var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_41)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5349 1.01532C7.29896 1.33937 1.40694 7.04917 1.02058 14.1167C0.705609 19.9167 4.03588 24.9908 8.9788 27.3493C10.8224 28.2271 13.0146 27.1237 13.3673 25.1507C13.6068 23.8217 12.9138 22.505 11.6749 21.9143C8.86541 20.5689 6.97979 17.6607 7.20238 14.3504C7.46275 10.4783 10.6712 7.33219 14.6356 7.06557C19.3224 6.74973 23.228 10.3717 23.228 14.8796C23.228 17.9765 21.3885 20.651 18.7176 21.9225C17.4997 22.505 16.8321 23.8135 17.0672 25.1178L17.0798 25.1835C17.4284 27.1237 19.5827 28.2271 21.3928 27.3698C26.1383 25.126 29.414 20.3762 29.414 14.8796C29.414 6.99584 22.6863 0.646154 14.5349 1.01532Z",
    fill: "#00AED6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2193 19.7607C12.4601 19.7607 10.2176 17.5703 10.2176 14.8754C10.2176 12.1804 12.4601 9.99005 15.2193 9.99005C17.9784 9.99005 20.221 12.1804 20.221 14.8754C20.221 17.5703 17.9784 19.7607 15.2193 19.7607Z",
    fill: "#00AED6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 27,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlue);
export default __webpack_public_path__ + "static/media/icon_blue.63a934a0dd3ea3ceea07982d6df5d92c.svg";
export { ForwardRef as ReactComponent };